import { useEffect, useState, useContext } from "react";
import useFetch from "../../hooks/use-fetch";
import { UserContext } from "../../context-provider/UserProvider";
import TableProvider from "../../context-provider/TableProvider";
import CompanySelect from "../company-select";
import ResponsesTable from "./response-table";

const ResponsesView = () => {
  const { companyId, setCompanyId } = useContext(UserContext);

  const api = useFetch({
    responses: [
      {
        guid: "",
        dateResponded: "",
        customerId: "",
        customerName: "",
        subscriptionId: "",
        subscriptionName: "",
        campaignName: "",
      },
    ],
  });

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "1em 0em",
        }}
      >
        <div
          style={{
            display: "flex",
          }}
        >
          <h2 style={{ marginRight: "15px" }}>Responses</h2>
          <CompanySelect setCompanyId={setCompanyId} />
        </div>
      </div>
      <TableProvider>
        <ResponsesTable api={api} companyId={companyId} />
      </TableProvider>
    </div>
  );
};

export default ResponsesView;
